<div class="page-container" *ngIf="hasAccess">
  <mat-card class="main-container">
    <mat-card-title>
      <div>
        <span class="card-title">My Profile</span>
        <span class="agency-title"
          >Agency ID:
          <span class="bold" style="font-size: 22px">{{ agencyId }}</span></span
        >
        <span class="legacyId" *ngIf="oldAgencyId != null"
          >Legacy ID: {{ oldAgencyId }}</span
        >
      </div>
    </mat-card-title>
    <mat-card-content>

      <table mat-table [dataSource]="dataSource" *ngIf="dataSource">
        <ng-container matColumnDef="agent">
          <td mat-cell *matCellDef="let element" class="agent-data">
            {{ element.agent }}:
          </td>
        </ng-container>

        <ng-container matColumnDef="data">
          <td
            mat-cell
            *matCellDef="let element"
            [ngClass]="{ bold: element.bold }"
          >
            {{ element.data }}
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </mat-card>

  <br />

  <!-- <mat-accordion> -->
    <!-- <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Agent Agreement, Renewal & Certificate
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-my-profile-agreement></app-my-profile-agreement>
    </mat-expansion-panel> -->

    <!-- <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Contact Information (Agent User Accounts)
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-my-profile-contact-information></app-my-profile-contact-information>
    </mat-expansion-panel> -->

    <!-- <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Company Information </mat-panel-title>
      </mat-expansion-panel-header>
      <app-my-profile-company-information></app-my-profile-company-information>
    </mat-expansion-panel> -->

    <!-- <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Mandatory Documents
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-my-profile-mandatory-documents></app-my-profile-mandatory-documents>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Financial Information
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-financial-information [agencyId]="agencyId" *ngIf="!isLoading"></app-financial-information>
    </mat-expansion-panel> -->

    <!-- <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Agent Training
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-agent-training></app-agent-training>
    </mat-expansion-panel> -->

    <!-- only agency_admin role can edit the agency contact information -->
  <div *ngIf="isAdmin">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Agency Contact Information</mat-panel-title>
        </mat-expansion-panel-header>
        <app-agency-contact-info
          [agencyId]="agencyId"
          [pendingMode]="pendingMode"
        >
        </app-agency-contact-info>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <!-- </mat-accordion> -->
  
      <!--Certificate button-->

      <button
        class="seneca-button"
        id="certificateBtn"
        (click)="onGenerateCertificate()"
        mat-flat-button
        color="primary"
      >
        <span> View Your Certificate </span>
      </button> 
</div>

<ng-template [ngIf]="!hasAccess">
  <div class="page-container">
    <mat-card class="main-container mat-elevation-z2">
      <mat-card-content>
        <h1>You do not have access to this page</h1>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
